export const contextSwitcherKeybinding = "ctrl+k";
export const preferencesKeybinding = "ctrl+,";
